$(function () {
    const $window = $(window);
    const $sidebar = $('#sidebar-navigation');
    const $dropdownToggle = $('.dropdown-toggle');
    const $dropdownContent = $sidebar.find('.dropdown-content');
    const $navItem = $('.nav-item');
    const $navSubItem = $('.nav-subitem');
    const $dashboardToggleBtn = $('#dashboard-toggle-btn, #dashboard-toggle-mobile-btn');
    const $canalysHeader = $('.entitled-user header');
    const $main = $("main");
    const $searchPageInput = $('#search-page');
    const isSearchPage = $searchPageInput.length > 0 && $searchPageInput.val().toLowerCase() === 'true';
    const $aiPageInput = $('#ai-page');
    const isAiPage = $aiPageInput.length > 0 && $aiPageInput.val().toLowerCase() === 'true';
    const $subscriptionOverviewPageInput = $('#subscription-overview-page');
    const isSubscriptionOverviewPage = $subscriptionOverviewPageInput.length > 0 && $subscriptionOverviewPageInput.val().toLowerCase() === 'true';

    // Mobile detection
    const isMobileView = () => window.visualViewport.width <= 800;

    // Default state
    $dropdownContent.addClass('show');
    $dropdownToggle.addClass('open');

    // Sidebar toggle
    $dashboardToggleBtn.on('click', function () {
        $sidebar.toggleClass('collapsed');
        $main.toggleClass('sidebar-navigation-hide');
        $canalysHeader.toggleClass('sidebar-navigation-hide');
    });

    // Dropdown toggle
    $(document).on('click', '.dropdown-toggle', function () {
        if ($main.hasClass('sidebar-navigation-hide')) return;

        const $toggle = $(this);
        const target = $toggle.data('target');
        const $dropdown = $('#' + target);
        $dropdown.toggleClass('show');
        $toggle.toggleClass('open');
    });

    // Regular nav item
    $(document).on('click', '.nav-item:not(.dropdown-toggle):not([data-toggle]):not([data-target])', function () {
        $navItem.removeClass('active');
        $(this).addClass('active');
    });

    // Sub-item click
    $(document).on('click', '.nav-subitem:not([data-toggle]):not([data-target])', function (e) {
        e.stopPropagation(); // fixed: added 'e' param
        $navItem.removeClass('active');
        $navSubItem.removeClass('active');
        $(this).addClass('active');
    });

    // Prevent dropdown content click bubbling
    $dropdownContent.on('click', function (e) {
        e.stopPropagation();
    });

    // Keyboard accessibility
    $dropdownToggle.on('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');
        }
    });

    // Mobile behavior handling
    const mobileMenu = function () {
        if (isMobileView()) {
            if($sidebar.hasClass('collapsed')) return;
            $main.addClass("sidebar-navigation-hide");
            $canalysHeader.addClass("sidebar-navigation-hide");
            $dropdownContent.addClass("show");
            $dropdownToggle.removeClass("open");
        } else {
            if (isSearchPage || isSubscriptionOverviewPage || isAiPage) {
                $sidebar.addClass('collapsed');
                $main.addClass('sidebar-navigation-hide');
                $canalysHeader.addClass('sidebar-navigation-hide');
            } else {
                $main.removeClass("sidebar-navigation-hide");
                $canalysHeader.removeClass("sidebar-navigation-hide");
                $sidebar.removeClass('collapsed');
            }
        }
    };

    if ((isSearchPage || isSubscriptionOverviewPage || isAiPage) && !isMobileView()) {
        $sidebar.addClass('collapsed');
        $main.addClass('sidebar-navigation-hide');
        $canalysHeader.addClass('sidebar-navigation-hide');
    }

    // Init and resize handling
    mobileMenu();

    // Back button handler (mobile)
    $('.back-button').on('click', function () {
        const $dropdown = $(this).closest('.dropdown-content');
        $dropdown.removeClass('show');
        // Remove 'open' from the corresponding toggle
        const toggleId = $dropdown.attr('id');
        $(`.dropdown-toggle[data-target="${toggleId}"]`).removeClass('open');
    });
    $window.on("resize", mobileMenu);
});

// place after your sidebar init code (e.g. at bottom of the file)
(function ensureActiveVisible() {
  const targetId = 'subscription-areas';
  const toggleSel = `.dropdown-toggle[data-target="${targetId}"]`;
  const maxRetries = 8;
  const retryDelay = 120; // ms

  let tries = 0;

  function doScroll() {
    tries++;
    const $dropdown = $('#' + targetId);
    const $toggle = $(toggleSel);
    const $active = $dropdown.find('.nav-subitem.active').first();

    if (!$active.length) return; // nothing to do

    // Ensure dropdown visible/open
    if (!$dropdown.hasClass('show')) {
      $dropdown.addClass('show');
      $toggle.addClass('open');
    }

    // measure and scroll; calculate position relative to scrollable container
    const container = $dropdown.get(0);
    const activeEl = $active.get(0);

    if (!container || !activeEl) return;

    const containerClientHeight = container.clientHeight || $dropdown.innerHeight();
    // Calculate element position relative to container's scrollable content
    const containerRect = container.getBoundingClientRect();
    const activeRect = activeEl.getBoundingClientRect();
    
    const elOffset = (activeRect.top - containerRect.top) + container.scrollTop;
    const elHeight = activeEl.offsetHeight || 0;

    // target scroll so active item is centered-ish
    const desiredScrollTop = Math.max(0, elOffset - (containerClientHeight / 2) + (elHeight / 2));

    // animate (smooth) — fallback to direct assignment if animate not available
    const animationDuration = 180;
    try {
      $dropdown.animate({ scrollTop: desiredScrollTop }, animationDuration);
    } catch (err) {
      container.scrollTop = desiredScrollTop;
    }

    const checkVisibility = () => {
      const containerRectNow = container.getBoundingClientRect();
      const activeRectNow = activeEl.getBoundingClientRect();

      const isVisible = activeRectNow.top >= containerRectNow.top && activeRectNow.bottom <= containerRectNow.bottom;
      if (!isVisible && tries < maxRetries) {
        setTimeout(doScroll, retryDelay);
      }
    };
    setTimeout(checkVisibility, animationDuration + 20);
  }

  // try on DOM ready, on window load, and also attempt after a small timeout
  $(document).ready(() => setTimeout(doScroll, 50));
  $(window).on('load', () => setTimeout(doScroll, 50));
  // also run once more after a short delay in case other scripts run later
  setTimeout(doScroll, 300);
})();
